<template>
  <div>
    <v-subheader class="text-overline">Search Results</v-subheader>

    <ListItem
      v-for="(item, index) in $store.state.search.search_results"
      :key="item.id"
      :item="item"
      :index="index"
      :unlocked="unlocked"
      link-location
    />

    <p v-if="!$store.state.search.search_results.length" class="text-body-2 pl-4 primary--text">
      Not Found!
    </p>
  </div>
</template>

<script>
import ListItem from "./ListItem";

export default {
  name: "SearchResults",
  components: { ListItem },
  computed: {
    unlocked() {
      return this.$store.state.lock.unlocked;
    },
  },
};
</script>
